import { useWindowIsMobile } from '@liveauctioneers/hammer-ui-core/providers';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { useAppSelector } from '@/redux/hooks';
import {
    getCatalogIsDone,
    getCatalogIsTimedPlus,
    getShouldShowLive,
} from '@/redux/modules/catalog/catalogs/catalog.selectors';

import { CoverLotsImageCluster } from './components/CoverLotsImageCluster/CoverLotsImageCluster';
import { LiveImageCluster } from './components/LiveImageCluster/LiveImageCluster';

type Props = {
    catalogId: number;
    className?: string;
    forceIsLive?: boolean;
};

export const HeaderImageCluster = ({ catalogId, className, forceIsLive = false }: Props) => {
    const isLiveFromStore = useAppSelector((state) => getShouldShowLive(state, catalogId));
    const isLive = forceIsLive || isLiveFromStore;
    const isCatalogDone = useAppSelector((state) => getCatalogIsDone(state, catalogId));
    const isTimedPlus = useAppSelector((state) => getCatalogIsTimedPlus(state, catalogId));
    const isMobile = useWindowIsMobile();

    if (isTimedPlus) {
        return null;
    }

    return (
        <div
            className={cn(
                `overflow-hidden rounded-md p-sm`,
                isLive && 'bg-background-critical-light',
                isCatalogDone && !isLive && !isMobile && 'bg-background-subdued',
                !isLive && !isCatalogDone && !isMobile && 'bg-background-secondary',
                className
            )}
            data-testid="catalog-header-image-cluster"
        >
            {isLive ? (
                <LiveImageCluster catalogId={catalogId} />
            ) : (
                <CoverLotsImageCluster
                    catalogId={catalogId}
                    isCatalogDone={isCatalogDone}
                />
            )}
        </div>
    );
};
